import { extendedColors, sysColors } from "@/assets/theme/colors";
import { LitCircularProgress, LitLinearProgress } from "./LitProgress";

const variants = {
  circular: LitCircularProgress,
  linear: LitLinearProgress
};

export type Variant = keyof typeof variants;

export type ProgressTone = "primary" | "success" | "warn" | "error";

const progressToneColors: Record<ProgressTone, string> = {
  primary: sysColors["sys-brand-primary"],
  success: extendedColors["extended-success-brand-color"],
  warn: extendedColors["extended-warning-brand-color"],
  error: sysColors["sys-brand-error"]
};

interface Props {
  variant?: Variant;
  size?: number;
  className?: string;
  color?: string;
  tone?: ProgressTone;
  activeIndicatorWidth?: number;
  value?: number;
}

export default function Progress({
  variant = "circular",
  size = 36,
  className,
  color,
  tone = "primary",
  activeIndicatorWidth,
  value
}: Props) {
  const ProgressComponent = variants[variant];

  const customStyles = {
    "--md-sys-color-primary": color ?? progressToneColors[tone],
    "--md-circular-progress-size": `${size}px`,
    ...(activeIndicatorWidth != null && { "--md-circular-progress-active-indicator-width": `${activeIndicatorWidth}` })
  } as React.CSSProperties & { [key: string]: string };

  return (
    <ProgressComponent
      {...(value != null ? { value: Math.min(1, Math.max(0, value)) } : { indeterminate: true })}
      style={customStyles}
      className={className}
      data-testid="progress-component"
    />
  );
}
